import { parse } from 'query-string';
import { PUSH, REPLACE, GO, GO_BACK, GO_FORWARD, LOCATION_CHANGE } from './constants';

export var push = function push(href) {
  return {
    type: PUSH,
    payload: href
  };
};

export var replace = function replace(href) {
  return {
    type: REPLACE,
    payload: href
  };
};

export var go = function go(index) {
  return {
    type: GO,
    payload: index
  };
};

export var goBack = function goBack() {
  return {
    type: GO_BACK
  };
};

export var goForward = function goForward() {
  return {
    type: GO_FORWARD
  };
};

export var locationChange = function locationChange(_ref) {
  var pathname = _ref.pathname,
      search = _ref.search,
      hash = _ref.hash;
  return {
    type: LOCATION_CHANGE,
    payload: {
      pathname: pathname,
      search: search,
      queries: parse(search),
      hash: hash
    }
  };
};